
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";

export default function WelcomePage() {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

         useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  useEffect(() => {
    if (!memberId) {
      setError("Missing member id");
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        // match your backend member-by-id endpoint
        const res = await axios.get(
          `https://gym-invoice-back.onrender.com/api/members/by-member-id/${memberId}`
        );
        setMember(res.data);
      } catch (err) {
        console.error("Error loading member:", err);
        setError("Failed to load member data.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [memberId]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) return <div className="welcome-wrap">Loading...</div>;
  if (error) return <div className="welcome-wrap error">{error}</div>;
  if (!member) return <div className="welcome-wrap">Member not found</div>;

  // Format dates
  const fmt = (dStr) => {
    if (!dStr) return "";
    const d = new Date(dStr);
    return d.toLocaleDateString();
  };

  // Activation date — show today (or you can use a server returned activation date)
  const activationDate = new Date().toLocaleDateString();

  const handleWhatsAppShare = () => {
    if (!member) return;

const message = `
*🎉 WELCOME TO LIFE FITNESS PARTNER 🎉*

━━━━━
*MEMBER DETAILS*
━━━━━
*Name:* ${member.name}

*Member ID:*
🟥 *\`${member.memberId}\`* 🟥

*Membership Type:* ${member.membershipType || "-"}

━━━━━
🏋️‍♂️ *GYM ETIQUETTE – PLEASE READ & FOLLOW* 🏋️‍♀
━━━━━
Maintaining proper gym etiquette helps keep the environment clean, safe, and comfortable for everyone.
A simple rule to remember is:

💪“Respect yourself, respect others, and respect the equipment.” 💪

*1. Bring a towel with you*
This helps prevent sweat from getting on benches and machines.

*2. Please wipe down equipment after use*
Keep the area clean and ready for the next person.

*3. Re-rack weights and dumbbells*
Always return plates, dumbbells, and bars to their proper place.

*4. Avoid sitting on machines while resting*
If you’re taking a break or using your phone, kindly step aside so others may use the equipment.

*5. Respect others’ personal space*
Give people enough room to exercise comfortably.

*6. Handle weights gently*
Avoid dropping weights loudly, as it may damage equipment and cause disturbance.

*7. Share equipment when possible*
Be courteous and allow others to work in between sets.

*8. Wear proper gym attire*
Kindly remove your outside shoes before entering the gym. Outside wore shoes and slippers not.
allowed.
Clean shoes and comfortable workout clothing are encouraged (no slippers or jeans).

*9. Do not record others without permission*
Everyone’s privacy must be respected.

*10. Keep mirrors clear*
Avoid standing in front of mirrors when someone is using them to check their form.

*11. Use machines and equipment safely*
Follow proper instructions to avoid damage or injury.

*12. Keep phone calls brief and quiet*
Loud conversations can distract others.

*13. Avoid giving unsolicited advice*
Only offer help or coaching if someone asks, or let trainers handle it.

━━━
*📞 Need Help?*
━━━━━
Contact us : +94-761330825
`;


    const url = "https://api.whatsapp.com/send?text=" + encodeURIComponent(message);

    window.open(url, "_blank");
  };


  return (
    <div className="welcome-wrap">



      <div className="welcome-card">
        <div className="welcome-header">
          <img src="/logo.png" alt="Gym Logo" className="gym-logo" onError={(e) => { e.target.style.display = 'none'; }} />
          <div className="gym-info">
            <h1>LIFE FITNESS PARTNER</h1>

            <p className="gym-contact">No. 62/2, Horana Road, Colombo •<br/> +94-76 133 0825</p>
          </div>
        </div>

        <div className="welcome-body">
          <h2 className="welcome-title">Welcome to the Gym!</h2>

          <div className="member-block">
            <div className="member-left">
              <p><strong>Member Name:</strong> {member.name}</p>
              <p><strong>Member ID:</strong> {member.memberId}</p>
              <p><strong>Membership Type:</strong> {member.membershipType || "-"}</p>
              <p><strong>Joined Date:</strong> {fmt(member.joinedDate)}</p>
            </div>

            <div className="member-right">


            </div>
          </div>

          <div className="hr" />

          <div className="bottom-row">
            <div>
              <p><strong>Terms:</strong></p>
              <ul>
                <li>Please mark your attendance every time you visit the gym using this link or by scanning the gym’s QR code:
                   <br/> https://gym-invoices-front.onrender.com/mark-attendance</li> <br/>

                <li>For any membership-related support, please contact the reception desk.</li>
              </ul>
            </div>


          </div>
        </div>

        <div className="welcome-footer no-print">
          <small>Generated: {new Date().toLocaleString()}</small>
        </div>

        <div className="welcome-actions no-print">
               <button className="pay-button"onClick={handleBack}>← Back</button>

               <button className="pay-button" onClick={handleWhatsAppShare}>
                 📲 Share on WhatsApp
               </button>

               <button className="pay-button" onClick={handlePrint}>
                 🖨️ Print
               </button>
             </div>
      </div>
    </div>
  );
}
